module.exports = __webpack_public_path__ + "static/media/bg.bbc7a84c.png";